/* Packages */
import React from 'react';
import { render } from 'react-dom';

const vehicleOverviewNodes = Array.from(document.querySelectorAll('[data-vehicle-overview]'));
if (vehicleOverviewNodes.length) {
    import(/* webpackChunkName: "VehicleOverview" */ './components/VehicleOverview').then(({ default: VehicleOverview }) => {
        vehicleOverviewNodes.forEach((node) => render(<VehicleOverview {...(JSON.parse(node.dataset.vehicleOverview || '{}'))} />, node));
    });
}
